import {
  additionalYSpace,
  date2Str,
  noNanNum
} from "@/_core/_helpers/_helpers";
import { timeParse, max, nest, sum } from "d3";
import {
  baseCurrencyFn,
  futureExpoData,
  timeCompare
} from "@/_core/data/AdvancedOld";
import { saveUserPreferences } from "@/_core/data/SaveToDB";
import moment from "moment";
import { getCommodityProgram } from "@/_core/data/api_calls/getCommodityProgram";
import { getCurrencyProgram } from "@/_core/data/api_calls/getCurrencyProgram";
import { getFutureExposureData } from "@/_core/data/api_calls/getFutureExposureData";
import { getFutureExposureCommodityData } from "@/_core/data/api_calls/getFutureExposureCommodityData";
import { getFutureHedgeData } from "@/_core/data/api_calls/getFutureHedgeData";
import { getFutureHedgeCommodityData } from "@/_core/data/api_calls/getFutureHedgeCommodityData";
import { simulateStrategies } from "@/_core/data/api_calls/simulateStrategies";
import { readCurrencyValuationDataOptimizer } from "@/_core/data/api_calls/readCurrencyValuationDataOptimizer";
import { readCommodityValuationDataOptimizer } from "@/_core/data/api_calls/readCommodityValuationDataOptimizer";
import {
  createChartsDataRaw,
  dataCompressCurrency
} from "@/_core/data/AdvancedOld";
import { formatDate_YMDSlash } from "@/_core/_helpers/_helpers.js";
import { formatPercentSm } from "@/_core/_helpers/_parametric_tools";
import { Holidays } from "@/_core/_helpers/holidays/Holidays";

export function getCountriesPair(_this) {
  let countryPerCurrency = [
    _this.currencySpecs[_this.selectedAsset].fk_idcurrency_left,
    _this.currencySpecs[_this.selectedAsset].fk_idcurrency_right
  ];
  return [
    _this.countrySpecs.filter(d => d.pk_idcountry === countryPerCurrency[0])[0]
      .iso,
    _this.countrySpecs.filter(d => d.pk_idcountry === countryPerCurrency[1])[0]
      .iso
  ];
}

export function holidaysCorrection(_this, country = null) {
  let holidays;
  if (country == null) {
    holidays = new Holidays(getCountriesPair(_this));
  } else {
    holidays = new Holidays(country);
  }
  _this.userNewHedge.forEach(function(d) {
    d.date = holidays.searchAvailableDate(d.date);
  });
}

export function createSelectedHedge(initialDate, notional, nDates, frequency) {
  initialDate = timeParse("%Y-%m-%d")(initialDate);
  let createdStrip;
  createdStrip = null;
  if (
    initialDate != null &&
    notional != null &&
    nDates != null &&
    frequency != null
  ) {
    createdStrip = [
      {
        date: date2Str(initialDate, 0),
        newHedge: notional
      }
    ];
    var newDate = initialDate;
    var i;
    for (i = 0; i < nDates - 1; i++) {
      newDate = nextDateByFrequency(frequency, newDate);
      createdStrip.push({
        date: date2Str(newDate, 0),
        newHedge: notional
      });
    }
  }
  return createdStrip;
}

export function nextDateByFrequency(frequency, newDate) {
  if (frequency === "D") {
    if (newDate.getDay() === 5) {
      newDate.setDate(newDate.getDate() + 3);
    } else {
      newDate.setDate(newDate.getDate() + 1);
    }
  } else if (frequency === "W") {
    newDate.setDate(newDate.getDate() + 7);
  } else if (frequency === "2W") {
    if (newDate.getDate() > 15) {
      newDate.setDate(newDate.getDate() - 15);
      newDate.setMonth(newDate.getMonth() + 1);
    } else {
      newDate.setDate(newDate.getDate() + 15);
    }
  } else if (frequency === "M") {
    newDate.setMonth(newDate.getMonth() + 1);
  } else if (frequency === "Q") {
    newDate.setMonth(newDate.getMonth() + 3);
  } else if (frequency === "S") {
    newDate.setMonth(newDate.getMonth() + 6);
  } else {
    newDate.setFullYear(newDate.getFullYear() + 1);
  }
  return newDate;
}

export function defineStrategyProfile(_this) {
  let pos = _this.selectedPosition === 1 ? "rProfileBuyer" : "rProfileSeller";
  _this.strategies.forEach(function(d) {
    d.rProfile = d[pos];
  });
}

export function positionSign(pos) {
  return pos.toUpperCase() === "LONG" ? "+" : "-";
}

export function initializeStrategiesRProfile(_this, justOne = false) {
  if (_this.selectedRiskProfile < 5 && _this.strategiesList.length > 0) {
    _this.strategies = [];
    let strats = strategiesIndex(
      _this.selectedRiskProfile,
      _this.selectedPosition
    );
    if (justOne) {
      includeStrategy(
        _this,
        _this.strategiesList[strats[0]],
        _this.selectedPosition
      );
    } else {
      strats.forEach(function(d) {
        includeStrategy(_this, _this.strategiesList[d], _this.selectedPosition);
      });
      _this.strategies.forEach(function(d, i) {
        d.show = false;
        d.id = i;
      });
      // _this.strategies[0].show = true;
      _this.selectedStrategy = {};
    }
  }
}

export function strategiesIndex(rProfile, position) {
  let strat;
  if (rProfile === 0) {
    if (position === 1) {
      strat = [0, 4, 16]; // , 18];
    } else {
      strat = [1, 6, 17]; // , 19];
    }
  } else if (rProfile === 1) {
    if (position === 1) {
      strat = [0, 8, 10]; // , 14];
    } else {
      strat = [1, 9, 12]; // , 15];
    }
  } else if (rProfile === 2) {
    if (position === 1) {
      strat = [0, 20, 22]; // , 26];
    } else {
      strat = [1, 21, 23]; // , 27];
    }
  } else if (rProfile === 3) {
    if (position === 1) {
      strat = [0, 30, 38];
    } else {
      strat = [1, 31, 39];
    }
  } else if (rProfile === 4) {
    if (position === 1) {
      strat = [0, 34, 40];
    } else {
      strat = [1, 35, 41];
    }
  } else {
    if (position === 1) {
      strat = [0];
    } else {
      strat = [1];
    }
  }
  return strat;
}

export function includeStrategy(_this, item, position) {
  let strat = {
    pk:
      _this.selectedAssetLink === 0
        ? item.pk_idcurrencystrategy
        : item.pk_idcommoditystrategy,
    numLegs: item.number_of_derivatives,
    data: [],
    id: _this.strategies.length,
    fixedCost: true,
    objectiveLeg: 1,
    first_second_strike_equal: item.first_second_strike_equal,
    name: item.name,
    rProfile:
      position === 1 ? item.risk_profile_buyer : item.risk_profile_seller,
    rProfileBuyer: item.risk_profile_buyer,
    rProfileSeller: item.risk_profile_seller,
    leg1:
      positionSign(item.first_derivative_position) +
      " " +
      item.first_derivative.toUpperCase(),
    leg2:
      item.number_of_derivatives >= 2
        ? positionSign(item.second_derivative_position) +
          " " +
          item.second_derivative.toUpperCase()
        : null,
    leg3:
      item.number_of_derivatives >= 3
        ? positionSign(item.third_derivative_position) +
          " " +
          item.third_derivative.toUpperCase()
        : null,
    leg4:
      item.number_of_derivatives === 4
        ? positionSign(item.fourth_derivative_position) +
          " " +
          item.fourth_derivative.toUpperCase()
        : null,
    isStrip1: false,
    isStrip2: false,
    isStrip3: false,
    isStrip4: false,
    derivative1: 1,
    derivative2: 1,
    derivative3: 1,
    derivative4: 1,
    strike1: 0,
    strike2: 0,
    strike3: 0,
    strike4: 0,
    barrier1: 0,
    barrier2: 0,
    barrier3: 0,
    barrier4: 0,
    barrier1_2: 0,
    barrier2_2: 0,
    barrier3_2: 0,
    barrier4_2: 0,
    cost:
      item.fk_idstrategyname === "FORWARD" ||
      item.fk_idstrategyname === "FUTURE"
        ? null
        : 0,
    costPerc: 0,
    active: true,
    percentage: 0,
    show: true,
    showLoading: false,
    calculated: false,
    simulated: false,
    warning: null
  };
  _this.strategies.push(strat);
  _this.selectedStrategy = strat;
}

export const OptimizerManager = function(_SelectedAsset, context) {
  this.selectedAsset = _SelectedAsset;
  this.asset = null;
  if (this.selectedAsset === 1) {
    this.asset = new CommoditiesOptimizer(context);
  } else if (this.selectedAsset === 0) {
    this.asset = new CurrenciesOptimizer(context);
  }
};

OptimizerManager.prototype.loadData = function() {
  this.asset.loadData();
};

OptimizerManager.prototype.setLoadData = function() {
  this.asset.setLoadData();
};

OptimizerManager.prototype.processBucket = function(
  bucket,
  lastBucket,
  objectNewHedge
) {
  this.asset.processDatabyBucket(bucket, lastBucket, objectNewHedge);
};

OptimizerManager.prototype.buildJsonStepOne = function() {
  this.asset.buildJsonStepOne();
};

OptimizerManager.prototype.mergeOnSpotChange = function(_this) {
  this.asset.mergeFromInputsValuation(_this);
};

export const CommoditiesOptimizer = function(context) {
  this.context = context;
};

export const CurrenciesOptimizer = function(context) {
  this.context = context;
};

CurrenciesOptimizer.prototype.loadData = function() {
  this.context.showLoadingTopographyCalcsRates = true;
  this.context.showLoadingFutExpo = true;
  this.context.showLoadingFutHedge = true;
  this.context.showLoadingProgram = true;
  getFutureExposureData(this.context, "expoDataRaw", "showLoadingFutExpo");
  getFutureHedgeData(this.context, "hedgeDataRaw", "showLoadingFutHedge");
  getCurrencyProgram(this.context, "programData", "showLoadingProgram");
};
CommoditiesOptimizer.prototype.loadData = function() {
  this.context.showLoadingTopographyCalcsRates = true;
  this.context.showLoadingFutExpo = true;
  this.context.showLoadingFutHedge = true;
  this.context.showLoadingProgram = true;
  getFutureExposureCommodityData(
    this.context,
    "expoDataRaw",
    "showLoadingFutExpo"
  );
  getFutureHedgeCommodityData(
    this.context,
    "hedgeDataRaw",
    "showLoadingFutHedge"
  );
  getCommodityProgram(this.context, "programData", "showLoadingProgram");
};

CurrenciesOptimizer.prototype.setLoadData = function() {
  let _this = this.context;
  createChartsDataRaw(
    _this,
    "expoDataRaw",
    "hedgeDataRaw",
    "programData",
    "dataRaw",
    true
  );
  dataCompressCurrency(_this, _this.dataRaw, _this.pickedBucket, "data", true);
  this.processData();
  _this.selectedHedge.splice(0, _this.selectedHedge.length);
  _this.data.forEach(function(row) {
    _this.selectedHedge.push({
      date: formatDate_YMDSlash(row.date),
      expo: Math.sign(row.tot) * row.tot,
      hedge: Math.sign(row.hedge) * row.hedge,
      program: Math.sign(row.program) * row.program,
      newHedge: 0,
      newHedgePercent: 0,
      totalHedgePercent: 0
    });
  });
  _this.onUserTotalPercOfRequiredChange(_this.totalPercOfRequired);
  _this.selectedHedgeSignal += 1;
};
CommoditiesOptimizer.prototype.setLoadData = function() {
  let _this = this.context;
  createChartsDataRaw(
    _this,
    "expoDataRaw",
    "hedgeDataRaw",
    "programData",
    "dataRaw",
    true
  );
  dataCompressCurrency(_this, _this.dataRaw, _this.pickedBucket, "data", true);
  this.processData();
  if (_this.selectedHedge.length > 0) {
    _this.selectedHedge.splice(0, _this.selectedHedge.length);
  }
  _this.data.forEach(function(row) {
    _this.selectedHedge.push({
      date: formatDate_YMDSlash(row.date),
      expo: Math.sign(row.tot) * row.tot,
      hedge: Math.sign(row.hedge) * row.hedge,
      program: Math.sign(row.program) * row.program,
      newHedge: 0,
      newHedgePercent: 0,
      totalHedgePercent: 0
    });
  });
  _this.onUserTotalPercOfRequiredChange(_this.totalPercOfRequired);
  _this.selectedHedgeSignal += 1;
};

CurrenciesOptimizer.prototype.processData = function() {
  let _this = this.context;
  _this.data.forEach(function(d) {
    d.tot = d.balance + d.cash_flow;
  });
  _this.data.forEach(function(d) {
    d.hedgeP = d.tot !== 0 ? formatPercentSm(d.hedge / d.tot) : "";
    d.programP = d.tot !== 0 ? formatPercentSm(d.program / d.tot) : "";
  });
  _this.data.forEach(function(d) {
    d.excess = 0;
    d.program =
      d.program === 0 && d.balance + d.cash_flow === 0 ? 0 : d.program;
  });
  baseCurrencyFn(_this);
};

CommoditiesOptimizer.prototype.processData = function() {
  let _this = this.context;
  _this.data.forEach(function(d) {
    d.tot = d.balance + d.cash_flow;
  });
  _this.data.forEach(function(d) {
    d.hedgeP = d.tot !== 0 ? formatPercentSm(d.hedge / d.tot) : "";
    d.programP = d.tot !== 0 ? formatPercentSm(d.program / d.tot) : "";
  });
  _this.data.forEach(function(d) {
    d.excess = 0;
    d.program =
      d.program === 0 && d.balance + d.cash_flow === 0 ? 0 : d.program;
  });
};

CurrenciesOptimizer.prototype.processDatabyBucket = function(
  bucket,
  intervalGroup,
  objectNewHedge
) {
  let _this = this.context;
  unCompressData(_this, _this.dataRaw, intervalGroup, objectNewHedge);
  dataCompressCurrency(_this, _this.dataRaw, bucket, "data", true);
  this.processData();
  _this.selectedHedge.splice(0, _this.selectedHedge.length);
  _this.data.forEach(function(row) {
    _this.selectedHedge.push({
      date: formatDate_YMDSlash(row.date),
      expo: Math.sign(row.tot) * row.tot,
      hedge: Math.sign(row.hedge) * row.hedge,
      program: Math.sign(row.program) * row.program,
      newHedge: noNanNum(row.newHedge),
      newHedgePercent: noNanNum(row.newHedgePercent),
      totalHedgePercent: noNanNum(row.totalHedgePercent)
    });
  });
  _this.onUserTotalPercOfRequiredChange(_this.totalPercOfRequired);
  _this.selectedHedgeSignal += 1;
};
CommoditiesOptimizer.prototype.processDatabyBucket = function(
  bucket,
  intervalGroup,
  objectNewHedge
) {
  let _this = this.context;
  unCompressData(_this, _this.dataRaw, intervalGroup, objectNewHedge);
  dataCompressCurrency(_this, _this.dataRaw, bucket, "data", true);
  this.processData();
  _this.selectedHedge.splice(0, _this.selectedHedge.length);
  _this.data.forEach(function(row) {
    _this.selectedHedge.push({
      date: formatDate_YMDSlash(row.date),
      expo: Math.sign(row.tot) * row.tot,
      hedge: Math.sign(row.hedge) * row.hedge,
      program: Math.sign(row.program) * row.program,
      newHedge: noNanNum(row.newHedge),
      newHedgePercent: noNanNum(row.newHedgePercent),
      totalHedgePercent: noNanNum(row.totalHedgePercent)
    });
  });
  _this.onUserTotalPercOfRequiredChange(_this.totalPercOfRequired);
  _this.selectedHedgeSignal += 1;
};

CurrenciesOptimizer.prototype.buildJsonStepOne = function() {
  this.getValuationInput();
};
CommoditiesOptimizer.prototype.buildJsonStepOne = function() {
  this.getValuationInput();
};

CurrenciesOptimizer.prototype.getValuationInput = function() {
  let _this = this.context;
  let daysToExpiration = _this.hedgeTemplate.map(d => d.days_to_expiration);
  _this["showLoadingValInputs"] = true;
  readCurrencyValuationDataOptimizer(_this, daysToExpiration)
    .then(data => {
      _this["valuationDataRaw"] = data["data"]["currency_valuation_inputs"];
      _this["showLoadingValInputs"] = false;
      this.mergeFromInputsValuation(_this);
    })
    .catch(function(error) {
      _this["showLoadingValInputs"] = false;
      _this["valuationDataRaw"] = [];
      console.log(error);
    });
};

CommoditiesOptimizer.prototype.getValuationInput = function() {
  let _this = this.context;
  let daysToExpiration = _this.hedgeTemplate.map(d => d.days_to_expiration);
  _this["showLoadingValInputs"] = true;
  readCommodityValuationDataOptimizer(_this, daysToExpiration)
    .then(data => {
      data = data["data"]["commodity_valuation_inputs"];
      data.forEach(function(d) {
        d.fwd = _this.spot;
      });
      Object.assign(_this, { valuationDataRaw: data });
      _this["showLoadingValInputs"] = false;
      this.mergeFromInputsValuation(_this);
    })
    .catch(function(error) {
      _this["showLoadingValInputs"] = false;
      _this["valuationDataRaw"] = [];
      console.log(error);
    });
};

CurrenciesOptimizer.prototype.mergeFromInputsValuation = async function(_this) {
  let indexes = _this.valuationDataRaw.map(d => d.days_to_expiration);
  let idx;
  let item;
  _this.hedgeTemplate.forEach(function(d) {
    idx = indexes.indexOf(d.days_to_expiration);
    if (idx > -1) {
      item = _this.valuationDataRaw[idx];
      d.c0 = item.c0;
      d.c1 = item.c1;
      d.c2 = item.c2;
      d.d0 = item.d0;
      d.r = item.r;
      d.rf = item.rf;
      d.fwd = _this.spot * Math.exp(d.time * (d.r - d.rf));
    }
  });
  _this.prevHedgeTemplate = _this.hedgeTemplate;
  _this.finalDate = max(_this.hedgeTemplate, function(d) {
    return d.date;
  });
  dataCompressCurrency(
    _this,
    futureExpoData(_this).concat(_this.hedgeTemplate),
    "1M",
    "dataSliced",
    true
  );
  await new Promise(resolve => setTimeout(resolve, 1000));
  _this.minMaxYAxisHist = _this.processData.minMax(
    _this.dataSliced,
    "m2m_rate",
    "m2m_rate",
    _this.minMaxYAxisHist
  );
  _this.minMaxYAxisRates = _this.processData.minMax(
    _this.hedgeData,
    "strike",
    "strike",
    [_this.minMaxYAxisHist[0], _this.minMaxYAxisHist[1]]
  );
  _this.minMaxYAxisRates = additionalYSpace(_this.minMaxYAxisRates, 0.05);
  _this.renderCharts += 1;
};

CommoditiesOptimizer.prototype.mergeFromInputsValuation = async function(
  _this
) {
  let indexes = _this.valuationDataRaw.map(d => d.days_to_expiration);
  let idx;
  let item;
  _this.hedgeTemplate.forEach(function(d) {
    idx = indexes.indexOf(d.days_to_expiration);
    if (idx > -1) {
      item = _this.valuationDataRaw[idx];
      d.c0 = item.c0;
      d.c1 = item.c1;
      d.c2 = item.c2;
      d.d0 = item.d0;
      d.r = item.r;
      d.fwd = item.fwd;
    }
  });
  _this.prevHedgeTemplate = _this.hedgeTemplate;
  _this.finalDate = max(_this.hedgeTemplate, function(d) {
    return d.date;
  });
  dataCompressCurrency(
    _this,
    futureExpoData(_this).concat(_this.hedgeTemplate),
    "1M",
    "dataSliced",
    true
  );
  await new Promise(resolve => setTimeout(resolve, 1000));
  _this.minMaxYAxisHist = _this.processData.minMax(
    _this.dataSliced,
    "m2m_rate",
    "m2m_rate",
    _this.minMaxYAxisHist
  );
  _this.minMaxYAxisRates = _this.processData.minMax(
    _this.hedgeData,
    "strike",
    "strike",
    [_this.minMaxYAxisHist[0], _this.minMaxYAxisHist[1]]
  );
  _this.minMaxYAxisRates = additionalYSpace(_this.minMaxYAxisRates, 0.05);
  _this.renderCharts += 1;
};

export function getPortfolios(_this) {
  var port = [];
  var opt = [];
  if (_this.companies.length > 0) {
    port = _this.companies[_this.selectedCompany].portfolios;
  } else {
    port = _this.companies[0].portfolios;
  }
  for (let i = 0; i < port.length; i++) {
    if (port[i].fk_currency.length !== 0) {
      opt.push({
        id: i,
        pk: port[i].pk_idportfolio,
        name: port[i].portfolio_name,
        asset: port[i].fk_currency
      });
    }
  }
  return opt;
}

export function getPortfoliosCommodities(_this) {
  var port = [];
  var opt = [];
  if (_this.companies.length > 0) {
    port = _this.companies[_this.selectedCompany].portfolios;
  } else {
    port = _this.companies[0].portfolios;
  }
  for (let i = 0; i < port.length; i++) {
    if (port[i].fk_idcommodity.length !== 0) {
      opt.push({
        id: i,
        pk: port[i].pk_idportfolio,
        name: port[i].portfolio_name,
        asset: port[i].fk_idcommodity
      });
    }
  }
  return opt;
}

export function unCompressData(_this, data, intervalGroup, objectNewHedge) {
  let counter = 0;
  let actualPercentage;
  let expoNoEx;
  nest()
    .key(function(d) {
      return timeCompare(d.date, intervalGroup, data);
    })
    .rollup(function(v) {
      _this.totExpoNoEx = 0;
      _this.bucketExcess = 0;
      _this.percentage =
        objectNewHedge[counter].newHedge / objectNewHedge[counter].expo;
      _this.toChange = _this.percentage;
      v.forEach(function(item) {
        item.tot = item.balance + item.cash_flow;
        item.expo = Math.sign(item.tot) * item.tot;
        actualPercentage = item.expo !== 0 ? item.hedge / item.expo : 0;
        _this.totExpoNoEx += actualPercentage > _this.toChange ? 0 : item.expo;
        _this.bucketExcess += Math.max(
          0,
          item.hedge - item.expo * _this.toChange
        );
      });

      v.forEach(function(item) {
        item.tot = item.balance + item.cash_flow;
        item.expo = Math.sign(item.tot) * item.tot;
        actualPercentage = item.expo !== 0 ? item.hedge / item.expo : 0;
        expoNoEx = actualPercentage > _this.toChange ? 0 : item.expo;
        item.newHedge =
          Math.max(0, _this.toChange - actualPercentage) * item.expo -
          (_this.bucketExcess * expoNoEx) / _this.totExpoNoEx;
        item.newHedge = Number.isNaN(item.newHedge) ? 0 : item.newHedge;
      });
      counter += 1;
    })
    .entries(data);
}

export function step1to2Currency(_this) {
  _this.hedgeTemplate = [];
  let idx = 0;
  if (_this.selectedTabNotional === 0) {
    _this.userNewHedge.forEach(function(d) {
      if (d.newHedge !== 0) {
        _this.hedgeTemplate.push(dataRawToTemplateHedge(idx, _this, d));
        idx += 1;
      }
    });
  } else {
    unCompressData(
      _this,
      _this.dataRaw,
      _this.pickedBucket,
      _this.selectedHedge
    );
    _this.dataRaw.forEach(function(d) {
      if (d.newHedge !== 0) {
        _this.hedgeTemplate.push(dataRawToTemplateHedge(idx, _this, d));
        idx += 1;
      }
    });
  }
  // Delete repeated dates
  _this.hedgeTemplate = getRepeatedDates(_this.hedgeTemplate);
}

function getRepeatedDates(data) {
  const groupedData = {};

  data.forEach(item => {
    const fixingDate = item.fixing_date;

    if (groupedData[fixingDate]) {
      groupedData[fixingDate].notional += item.notional;
    } else {
      groupedData[fixingDate] = {
        ...item
      };
    }
  });

  const resultArray = Object.values(groupedData);
  return resultArray;
}

export function dataRawToTemplateHedge(idx, _this, d) {
  let days2Exp = moment(d.date).diff(moment(_this.todayDate), "days");
  let dat =
    _this.selectedTabNotional === 0 ? timeParse("%Y-%m-%d")(d.date) : d.date;
  let item = {
    asian_fixing_start_date: null,
    balance: 0,
    barrier_2_event: false,
    barrier_2: null,
    barrier_event: false,
    barrier: null,
    budget_rate: 0,
    buy_sell: "",
    c0: null,
    c1: null,
    c2: null,
    cash_flow: d.newHedge,
    comments: "",
    counterparty: "QUANSPIRE",
    counterpartys_id: null,
    curr: "",
    currency: "",
    d0: null,
    date: dat,
    days_to_expiration: days2Exp,
    delta: 0,
    derivative_purpose: "",
    derivative: "",
    derivative_type: "",
    dt_asian: null,
    dtn_asian: null,
    fixing_date: dat,
    fixation_date: dat,
    fwd: null,
    foreign_currency: "",
    hedge_value: 0,
    hedge: 0,
    hedgeNotional: null,
    hedgeValue: 0,
    hedged_date: null,
    historicalIndex: null,
    index: idx,
    known_ave: null,
    mark_2_market: 0,
    m_asian: null,
    new_event: false,
    notional: d.newHedge,
    option_type: "",
    pk: null,
    pk_idcurrencyhedge: null,
    portfolio: null,
    position: null,
    premium_value_date: _this.todayDate,
    premium: 0,
    premium_left: null,
    program: 0,
    quantity: d.newHedge,
    quantity_hedge: d.newHedge,
    r: null,
    ratio: 1,
    rf: null,
    sale_date: null,
    settlement_type: "NON DELIVERABLE",
    spot_reference: null,
    spot: null,
    strategy_code: null,
    strategy_name: "",
    strategy_value: 0,
    strike: 0,
    time: days2Exp / 365,
    trade_date: _this.todayDate,
    undated: 0,
    unit: "",
    updated_at: null,
    undelying_position: -_this.selectedPosition,
    value_date: dat,
    volatility: 0
  };

  if (_this.selectedAssetLink === 0) {
    if (_this.selectedTabNotional === 0) {
      item.currency = _this.currencySpecs[_this.selectedAsset].currency_name;
      item.foreign_currency = _this.currencySpecs[
        _this.selectedAsset
      ].currency_name.slice(0, 3);
    } else {
      item.currency = _this.currencyString;
      item.portfolio = _this.portfolios[_this.selectedPortfolio].name;
    }
  } else {
    if (_this.selectedTabNotional === 0) {
      _this.commodityString =
        _this.commoditySpecs[_this.selectedAsset].fk_idproduct;
    } else {
      _this.commodityString = _this.assets[_this.selectedPortCommodity];
    }
    item.unit = _this.commoditySpecs[_this.selectedAsset].fk_idunit;
    item.curr = _this.commoditySpecs[_this.selectedAsset].fk_idcurrency;
    item.contract_month_year =
      _this.spotStrip[_this.contract - 1].contract_month_year;
    item.contract_month_year_hedge =
      _this.spotStrip[_this.contract - 1].contract_month_year;
  }

  return item;
}

export function getPlusCarouselPage() {
  let prevPage = document
    .getElementById("step-1-div")
    .className.includes("active")
    ? 0
    : document.getElementById("step-2-div").className.includes("active")
    ? 1
    : document.getElementById("step-3-div").className.includes("active")
    ? 2
    : 3;
  return prevPage === 3 ? 0 : prevPage + 1;
}

export function getMinusCarouselPage() {
  let prevPage = document
    .getElementById("step-1-div")
    .className.includes("active")
    ? 0
    : document.getElementById("step-2-div").className.includes("active")
    ? 1
    : document.getElementById("step-3-div").className.includes("active")
    ? 2
    : 3;
  return prevPage === 0 ? 3 : prevPage - 1;
}

export function writeStrategySummary(_this, idx, summary) {
  _this.strategies[idx].cost =
    summary[0]["cost"] == null ? null : -summary[0]["cost"];
  _this.strategies[idx].costPerc =
    -Math.round(summary[0]["costPerc"] * 10000) / 100;
  _this.strategies[idx].strike1 = summary[0]["strike1"];
  _this.strategies[idx].strike2 = summary[0]["strike2"];
  _this.strategies[idx].strike3 = summary[0]["strike3"];
  _this.strategies[idx].strike4 = summary[0]["strike4"];
  _this.strategies[idx].isStrip1 = summary[0]["isStrip1"];
  _this.strategies[idx].isStrip2 = summary[0]["isStrip2"];
  _this.strategies[idx].isStrip3 = summary[0]["isStrip3"];
  _this.strategies[idx].isStrip4 = summary[0]["isStrip4"];
  _this.strategies[idx].barrier1 = summary[0]["barrier1"];
  _this.strategies[idx].barrier2 = summary[0]["barrier2"];
  _this.strategies[idx].barrier3 = summary[0]["barrier3"];
  _this.strategies[idx].barrier4 = summary[0]["barrier4"];
  _this.strategies[idx].barrier1_2 = summary[0]["barrier1_2"];
  _this.strategies[idx].barrier2_2 = summary[0]["barrier2_2"];
  _this.strategies[idx].barrier3_2 = summary[0]["barrier3_2"];
  _this.strategies[idx].barrier4_2 = summary[0]["barrier4_2"];
  _this.strategies[idx].warning = summary[0]["warning"];
}

export function setBaseCurrency(_this) {
  let curr = _this.currencyString;
  _this.baseCurrency = {
    rate: curr,
    foreign: curr.slice(0, 3),
    base: curr.slice(3, 6),
    changeBase: "N.A."
  };
}

export function filterCurrenciesWithValuationData(original) {
  let newData = [];
  let names = original.map(d => d.currency_name);
  let idx;
  let availableCurrencies = [
    "EURGBP",
    "EURUSD",
    "GBPUSD",
    "USDBRL",
    "USDCLP",
    "USDCOP",
    "USDMXN"
  ];
  availableCurrencies.forEach(function(d) {
    idx = names.indexOf(d);
    newData.push(original[idx]);
  });
  return newData;
}

function isLongOrShort(longShort) {
  return longShort === "long" ? "compra" : "vende";
}

export function createExcelForStrategy(_this, data, strategy) {
  let dat;
  let pk;
  _this.excelData = [];
  data
    .filter(d => d.leg === 1)
    .forEach(function(d) {
      pk = d.pk;
      dat = {
        [_this.isCurrency ? "fixing_date" : "date"]: d.date,
        notional: d.notional,
        strike1: d.strike,
        strategy_name: d.strategy_name,
        spot_reference: d.spot_reference,
        premium: d.premium,
        premium_currency: `Prima ${d.currency}`,
        mark_2_market: d.mark_2_market,
        leg1: _this.isCurrency
          ? `${isLongOrShort(strategy.first_derivative_position)} ${
              strategy.first_derivative
            }`
          : d.strike
      };
      if (!_this.isCurrency) {
        dat.label1 =
          strategy.first_derivative_position + " " + strategy.first_derivative;
      }
      _this.excelData.push(dat);
    });
  if (strategy.number_of_derivatives >= 2) {
    data
      .filter(d => d.leg === 2)
      .forEach(function(d, i) {
        _this.excelData[i].strike2 = d.strike;
        _this.excelData[i].premium = _this.excelData[i].premium + d.premium;
        _this.excelData[i].mark_2_market =
          _this.excelData[i].mark_2_market + d.mark_2_market;
        _this.excelData[i].leg2 = _this.isCurrency
          ? `${isLongOrShort(strategy.second_derivative_position)} ${
              strategy.second_derivative
            }`
          : d.strike;
        if (!_this.isCurrency) {
          _this.excelData[i].label2 =
            strategy.second_derivative_position +
            " " +
            strategy.second_derivative;
        }
      });
  }
  if (strategy.number_of_derivatives >= 3) {
    data
      .filter(d => d.leg === 3)
      .forEach(function(d, i) {
        _this.excelData[i].strike3 = d.strike;
        _this.excelData[i].premium = _this.excelData[i].premium + d.premium;
        _this.excelData[i].mark_2_market =
          _this.excelData[i].mark_2_market + d.mark_2_market;
        _this.excelData[i].leg3 = _this.isCurrency
          ? `${isLongOrShort(strategy.third_derivative_position)} ${
              strategy.third_derivative
            }`
          : d.strike;

        if (!_this.isCurrency) {
          _this.excelData[i].label3 =
            strategy.third_derivative_position +
            " " +
            strategy.third_derivative;
        }
      });
  }
  if (strategy.number_of_derivatives >= 4) {
    data
      .filter(d => d.leg === 4)
      .forEach(function(d, i) {
        _this.excelData[i].strike4 = d.strike;
        _this.excelData[i].premium = _this.excelData[i].premium + d.premium;
        _this.excelData[i].mark_2_market =
          _this.excelData[i].mark_2_market + d.mark_2_market;
        _this.excelData[i].leg4 = _this.isCurrency
          ? `${isLongOrShort(strategy.fourth_derivative_position)} ${
              strategy.fourth_derivative
            }`
          : d.strike;

        if (!_this.isCurrency) {
          _this.excelData[i].label4 =
            strategy.fourth_derivative_position +
            " " +
            strategy.fourth_derivative;
        }
      });
  }

  if (pk) _this.accumExcelData[pk] = _this.excelData;
}

export function getObjectiveLeg(leg, selectedStrategy) {
  return leg === 1
    ? selectedStrategy.isStrip1
    : leg === 2
    ? selectedStrategy.isStrip2
    : leg === 3
    ? selectedStrategy.isStrip3
    : selectedStrategy.isStrip4;
}

export function buildPortfolioSimulations(_this, percentageById) {
  let keys = Object.keys(percentageById);
  delete keys.rates;
  delete keys.result;
  _this.simulations.forEach(function(d) {
    d.result =
      d.rates +
      sum(keys, function(key) {
        return (d[key] * percentageById[key]) / 100;
      });
  });
  _this.simulationsSliced.forEach(function(d) {
    d.result =
      d.rates +
      sum(keys, function(key) {
        return (d[key] * percentageById[key]) / 100;
      });
  });
  _this.renderSimulationChartSignal += 1;

  portfolioStatistics(_this);
}

export function portfolioStatistics(_this) {
  let not = _this.notionalTotal;
  let conf;
  if (_this.selectedPosition === -1) {
    conf = (100 - _this.confidence) / 200;
  } else {
    conf = 1 - (1 - _this.confidence / 100) / 2;
    not *= -1;
  }
  let arr = Array.from(_this.simulations, d => d.rates);
  let res = Array.from(_this.simulations, d => d.result).sort(function(a, b) {
    return a - b;
  });
  _this.portfolioStats.var = _this.processData.percentile(arr, conf);
  _this.portfolioStats.best = _this.processData.percentile(arr, 1 - conf);
  _this.portfolioStats.varH = _this.processData.percentile(res, conf);
  _this.portfolioStats.bestH = _this.processData.percentile(res, 1 - conf);
  _this.portfolioStats.ave = _this.processData.average(arr);
  _this.portfolioStats.aveH = _this.processData.average(res);
  _this.portfolioStats.varPnl = not * _this.portfolioStats.var;
  _this.portfolioStats.bestPnl = not * _this.portfolioStats.best;
  _this.portfolioStats.avePnl = not * _this.portfolioStats.ave;
  _this.portfolioStats.varPnlH = not * _this.portfolioStats.varH;
  _this.portfolioStats.bestPnlH = not * _this.portfolioStats.bestH;
  _this.portfolioStats.avePnlH = not * _this.portfolioStats.aveH;
}

// === OPTIMIZER: Ready to Simulate? === //
export function readyToSimulate(_this) {
  if (_this.carouselPage === 2) {
    let bool = true;
    _this.strategies.forEach(function(d) {
      if (d.calculated === false) {
        bool = false;
      }
    });
    let bool2 = true;
    _this.strategies.forEach(function(d) {
      if (d.simulated === false) {
        bool2 = false;
      }
    });
    if (bool && !bool2) {
      simulateStrategies(_this, "simulations", "showLoadingSimulating");
    }
    if (bool && bool2) {
      let percentageById = {};
      _this.strategies.forEach(function(d) {
        percentageById[d.id] = d.percentage;
      });
      setTimeout(() => {
        buildPortfolioSimulations(_this, percentageById);
      }, 1000);
    }
  }
}

export function simulationsDataPrep(_this) {
  _this.simulationsSliced = _this.simulations.slice(0, 1000);
  _this.simulations = _this.simulations.sort((a, b) =>
    a.rates > b.rates ? 1 : b.rates > a.rates ? -1 : 0
  );
  _this.minMaxSim = [
    _this.simulations[0].rates,
    _this.simulations[_this.simulations.length - 1].rates
  ];
  _this.minMaxSimP[0] = _this.processData.percentile(
    Array.from(_this.simulations, d => d.rates),
    0.05
  );
  _this.minMaxSimP[1] = _this.processData.percentile(
    Array.from(_this.simulations, d => d.rates),
    0.95
  );
}

export function highlightOnOff(_this, fieldName) {
  _this[fieldName] = true;
  setTimeout(() => {
    _this[fieldName] = false;
  }, 500);
}

export function getDefaultOptimizerPreferences(_this) {
  if (
    Object.keys(_this.$store.state.user_preferences.all.items.optimizer_choices)
      .length === 0
  ) {
    let choices = {
      selected_nav: 0,
      selected_currency: 2,
      selected_commodity: 7,
      color_theme: false,
      buy_sell: 0,
      select: 0
    };
    _this.$store.state.user_preferences.all.items.optimizer_choices = choices;
    saveUserPreferences(_this);
    return { choices };
  } else {
    let choices =
      _this.$store.state.user_preferences.all.items.optimizer_choices;
    return { choices };
  }
}
